// Timezone-safe helpers for pure calendar dates (DOB, sign date, etc.).
//
// Why this exists:
// A DATE column has no time and no timezone, but mysql2 serializes it as
// UTC midnight — e.g. the stored date 1971-12-09 arrives as
// "1971-12-09T00:00:00.000Z". Passing that straight into `new Date(...)`
// and rendering it (toLocaleDateString / date-fns format) uses the
// VIEWER's timezone, which shifts the calendar day: in the Americas the
// instant falls on the previous evening, so Dec 9 renders as Dec 8. That
// made the on-screen profile DOB disagree with the (correct) contract PDF,
// which reads the raw Y-M-D. These helpers take the Y-M-D components
// verbatim so the rendered day always matches the stored value, for every
// viewer timezone.

// Parse a 'YYYY-MM-DD' or ISO date into a Date at LOCAL midnight, using the
// calendar components as-is (no timezone shift). Returns null when empty /
// unparseable.
export function parseCalDate(d) {
  if (!d) return null;
  const m = String(d).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const dt = new Date(d);
  return isNaN(dt.getTime()) ? null : dt;
}

// Localized date string for a calendar date, timezone-safe. Mirrors a bare
// `new Date(x).toLocaleDateString(...)` but without the day-shift. Returns ''
// when the value is empty.
export function formatCalDate(d, locales, options) {
  const dt = parseCalDate(d);
  if (!dt) return '';
  return dt.toLocaleDateString(locales, options);
}
